<div class="text-white">
    <p>Copyright &copy; 2134 Todos los derechos reservados</p>
</div>
